/* eslint-disable import/prefer-default-export */
export enum WindowPopupStatus {
  IDLE = "idle",
  PENDING = "pending",
  CLOSED = "closed",
}
